import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'
import { size, width } from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  background-color: ${theme.palette.background.accent};
  padding: clamp(${size[40]}, 5vw + ${size[16]}, ${size[80]}) 0;
`

export const container = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};
  max-width: ${width.container.wider};
  padding: 0 ${size[24]};
  margin: auto;
`

export const list = css`
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: ${size[32]};
  overflow: visible;
`

export const listItem = (theme: Theme) => css`
  &:after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background-color: ${theme.palette.background.accent};
    transform: translateY(${size[16]});
  }
`
